// frontend-react/src/services/imageDescriptionService.ts
import apiClient from './apiClient';

export interface ImageDescriptionStatus {
  status: 'processing' | 'done' | 'error';
  error?: string | null;
}

/**
 * 上傳 DOCX 或 PDF，啟動圖片說明任務。
 * placement: 'after_image'（圖片後方插入）或 'appendix'（集中到文末附錄）
 * 回傳 task_id，前端再輪詢狀態。
 */
export async function submitImageDescription(
  file: File,
  placement: 'after_image' | 'appendix' | 'caption_only' = 'caption_only'
): Promise<{ task_id: string }> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('placement', placement);
  const resp = await apiClient.post<{ task_id: string }>(
    '/api/v1/document/image-description',
    formData
  );
  return resp.data;
}

/**
 * 查詢圖片說明任務狀態。
 */
export async function pollImageDescriptionStatus(taskId: string): Promise<ImageDescriptionStatus> {
  const resp = await apiClient.get<ImageDescriptionStatus>(
    `/api/v1/document/image-description/${taskId}/status`
  );
  return resp.data;
}

/**
 * 觸發瀏覽器下載圖片說明 Word 文件。
 */
export async function downloadImageDescription(
  taskId: string,
  originalFilename: string
): Promise<void> {
  const resp = await apiClient.get(`/api/v1/document/image-description/${taskId}/download`, {
    responseType: 'blob',
  });

  const stem = originalFilename.replace(/\.(pdf|docx)$/i, '');
  const filename = `OCR_${stem}.docx`;

  const url = URL.createObjectURL(new Blob([resp.data]));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
